<div [@routerTransition]>
    <div class="m-subheader ">
        <div class="row align-items-center">
            <div class="mr-auto col-sm-12 col-md-6">
                <h3 class="m-subheader__title">
                    <span>{{l("Notifications")}}</span>
                </h3>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
                <button class="btn btn-success" (click)="openNotificationSettingsModal()"><i class="fa fa-cog"></i> {{l("NotificationSettings")}}</button>
                <button class="btn btn-primary blue" (click)="setAllNotificationsAsRead()"><i class="fa fa-check"></i> {{l("SetAllAsRead")}}</button>
            </div>
        </div>
    </div>
    <div class="m-content">
        <div class="m-portlet m-portlet--mobile">
            <div class="m-portlet__body">
                <div class="m-form m-form--label-align-right">
                    <div class="row m--margin-bottom-10">
                        <div class="col-xl-6">
                            <div class="form-group">
                                <select #TargetValueFilterSelectionCombobox
                                        class="form-control"
                                        [(ngModel)]="readStateFilter"
                                        name="readStateFilter"
                                        jq-plugin="selectpicker">
                                    <option value="ALL">{{l("All")}}</option>
                                    <option value="UNREAD">{{l("Unread")}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-xl-6 text-right">
                            <div class="form-group">
                                <button class="btn btn-metal" (click)="getNotifications()"><i class="fa fa-refresh"></i> {{l("Refresh")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container" [busyIf]="primengDatatableHelper.isLoading">
                        <p-dataTable #dataTable
                                     (onLazyLoad)="getNotifications($event)"
                                     [value]="primengDatatableHelper.records"
                                     rows="{{primengDatatableHelper.defaultRecordsCountPerPage}}"
                                     [paginator]="false"
                                     [lazy]="true"
                                     emptyMessage="{{l('NoData')}}"
                                     [responsive]="primengDatatableHelper.isResponsive">
                            <p-column field="" [sortable]="false" header="{{l('Actions')}}" [style]="{'width':'130px','text-align':'center'}">
                                <ng-template let-record="rowData" pTemplate="body">
                                    <div class="btn-group dropdown">
                                        <button class="btn btn-sm btn-primary blue" title="{{l('SetAsRead')}}" (click)="setAsRead(record)" [disabled]="isRead(record)">
                                            <i class="fa fa-check" *ngIf="isRead(record)"></i>
                                            <i class="fa fa-circle-o" *ngIf="!isRead(record)"></i>
                                        </button>
                                    </div>
                                </ng-template>
                            </p-column>
                            <p-column field="notification" header="{{l('Notification')}}">
                                <ng-template let-record="rowData" pTemplate="body">
                                    <a *ngIf="record.formattedNotification.url" href="{{record.formattedNotification.url}}" class="{{getRowClass(record)}}">{{truncateString(record.formattedNotification.text, 120)}}</a>
                                    <span *ngIf="!record.formattedNotification.url" title="{{record.formattedNotification.text}}" class="{{getRowClass(record)}}">{{truncateString(record.formattedNotification.text, 120)}}</span>
                                </ng-template>
                            </p-column>
                            <p-column field="creationTime" header="{{l('CreationTime')}}" [sortable]="false">
                                <ng-template let-record="rowData" pTemplate="body">
                                    <span title="{{record.notification.creationTime | momentFormat:'llll'}}" class="{{getRowClass(record)}}">
                                        {{fromNow(record.notification.creationTime)}}
                                    </span>
                                </ng-template>
                            </p-column>
                        </p-dataTable>
                        <div class="primeng-paging-container">
                            <p-paginator rows="{{primengDatatableHelper.defaultRecordsCountPerPage}}"
                                         #paginator
                                         (onPageChange)="getNotifications($event)"
                                         [totalRecords]="primengDatatableHelper.totalRecordsCount"
                                         [rowsPerPageOptions]="primengDatatableHelper.predefinedRecordsCountPerPage">
                            </p-paginator>
                            <span class="total-records-count">
                                {{l('TotalRecordsCount', primengDatatableHelper.totalRecordsCount)}}
                            </span>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/layout/notifications/notifications.component.html